import { userLogout } from "../Redux/Features/userSlice";

const authMiddleware = store => next => action => {

    if (
        action.type.endsWith('/rejected') &&
        action.payload?.status === 401 &&
        action.type !== 'users/get-user/rejected'
    ) {
        store.dispatch(userLogout());
        window.location.href = '/login';
    }

    return next(action);
};

export default authMiddleware;